import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import FormSectionTitle from '@src/components/Form/FormSectionTitle'
import { useTabs, ASSSTabs, getTabsByType } from '@src/components/Tabs/useTabs'
import TabsComp, { Tab } from '@src/components/Tabs/Tabs'
import { ProjectTypeId } from '@src/types/ProjectTypeId'
import TabsWrapper from '@src/modules/SiteResoureRequirements/comps/TabsWrapper'
import { useDRS } from '../../useDRS'
import PartDRSMobileAssets from './parts/MobileAssets'

interface Props {
type: any
}

const CompDRSMobileAssets = (props: Props) => {
  const {
    type
  } = props
  const [ tabIndex, tabs, handleTabChange, setTabs ] = useTabs(ASSSTabs)
  const { drs } = useDRS()
  useEffect(() => {
    if (drs !== null) {
      setTabs(getTabsByType(drs.jobDetails.drsProjectType.id))
    }
  }, [drs])
  
  const renderAsOrSS = () => {
    const currentTab: Tab = tabs[tabIndex]
    if (currentTab.key === ProjectTypeId.Asphalt) {
      return <React.Fragment>
        <PartDRSMobileAssets type={type} projectTypeId={ProjectTypeId.Asphalt}/>
      </React.Fragment>
    } else {
      return <React.Fragment>
        <PartDRSMobileAssets  type={type} projectTypeId={ProjectTypeId.SpraySeal}/>
      </React.Fragment>
    }
  }

  return <Wrapper>
    <FormSectionTitle>Mobile Assets</FormSectionTitle>
    <TabsWrapper>
      <TabsComp 
        tabs={tabs} 
        activeIndex={tabIndex}
        onChange={handleTabChange}
      />
    </TabsWrapper>
    { renderAsOrSS() }
  </Wrapper>
}

const Wrapper = styled.div`

`
export default CompDRSMobileAssets